import { useEffect, useState } from "react";
import { onValue, ref } from "firebase/database";
import { rdb } from "@/services/config";

export const usePresenceMap = () => {
  const [presenceMap, setPresenceMap] = useState<Record<string, any>>({});

  useEffect(() => {
    const statusRef = ref(rdb, "status");

    const unsubscribe = onValue(statusRef, (snap) => {
      setPresenceMap(snap.val() || {});
    });

    return () => unsubscribe();
  }, []);

  return presenceMap;
};
